import { autoGeneratedReducer } from '@hh.ru/redux-create-reducer';

import { PictureType, PictureSetting } from 'src/models/vacancyConstructorTemplate/vacancyConstructorTypes';

export type VacancyConstructorSettings = Partial<Record<PictureType, PictureSetting>>;

const vacancyConstructorSettings = autoGeneratedReducer<VacancyConstructorSettings>(null);
export { vacancyConstructorSettings };
